import React from 'react'
import { Button, Modal, Tooltip } from 'antd'
// import {
//   ExclamationCircleOutlined
// } from '@ant-design/icons'

import Viewer from 'components/ImageViewer'
import ReactPlayer from 'react-player'

// import { readEml } from 'eml-parse-js'
// import htmlEncodingSniffer from 'html-encoding-sniffer'

import i18n from 'i18n'
import classNames from 'classnames'

import { Provider } from 'react-redux'
import { store } from 'index'
import { errorBase } from 'utils/ui'

import { getPreviewType } from './helper'
import type { Attachment as BaseAttachment } from './helper'

// import EmailView from 'pages/main/components/EmailView'
import FTIcon from 'components/FTIcon'
import { SVGImageCurrentColor } from 'utils/svgHelper'
import ThreadView from 'pages/main/components/ThreadView'

import { parseEMLByPostalMime } from 'pages/main/data/EmailObj'
import { createEMLEmail } from 'pages/main/data/EMLEmail'
import DocViewer, { isSafari, isFirefox, buildDocViewerUrl } from 'app/components/DocViewer'

import closeSVG from 'assets/images/toolbar-close.svg'
import openInSVG from 'assets/images/toolbar-open-in.svg'
import downloadSVG from 'assets/images/button-download.svg'

import styles from './style.module.scss'

interface DownloadOptions {
  onDownload?: (downloadObj: any) => void | Promise<void>
}

interface ModalExt {
  clsNames: any
  renderTitle: (() => any) | null
  getTitle: () => any
  afterClose: () => void
  startSpinning: () => void
  stopSpinning: () => void
  renderProgress: () => React.ReactElement
  renderContent: (() => React.ReactElement) | null
  render: () => React.ReactElement
  modal: any
  update: (options?: any) => void
  download: (options?: DownloadOptions) => void
  spinning?: boolean
  spiningTimer?: NodeJS.Timeout | null
}

interface Attachment extends BaseAttachment {
  info?: {
    filesize?: number
  }
  downloadPercent: number
  progressStatus: any
  strokeColor?: string
  viewerVisible?: boolean
  isVideo?: boolean
  canPlay?: boolean
  showPopup: (clsName: any, downloadOptions: DownloadOptions, container?: any) => ModalExt
  showImage: () => void
  showVideo: () => void
  showText: () => void
  showEML: (container: any, apiMap: any) => void
  showDOC: () => void
  showPreview: (apiMap?: any) => boolean
}

export function extendUI(attachment: BaseAttachment): Attachment {
  const self = attachment as any as Attachment

  self.showPopup = (clsName: any, downloadOptions: DownloadOptions, container?: any): ModalExt => {
    self.downloadPercent = 0

    self.progressStatus = null

    const modalExt: ModalExt = {
      clsNames: clsName,
      spinning: false,
      renderTitle: null,
      getTitle: () => {
        if (modalExt.renderTitle != null) {
          return modalExt.renderTitle()
        }
        return null
      },
      afterClose: () => {
        self.cancelProgress()
      },
      startSpinning: () => {
        modalExt.spinning = true
        modalExt.spiningTimer = setTimeout(() => {
          modalExt.spiningTimer = null
          modalExt.spinning = false
          modalExt.update()
        }, 3000)
      },
      stopSpinning: () => {
        if (modalExt.spiningTimer != null) {
          clearTimeout(modalExt.spiningTimer)
          modalExt.spiningTimer = null
          modalExt.spinning = false
          modalExt.update()
        }
      },
      renderProgress: () => {
        const isSpinning = modalExt.spinning && self.downloadPercent <= 0
        return (
          <div className={classNames(styles.content, { spinning: isSpinning })}>
            {/* <Spin
              tip={`${i18n.t('email.result.loading')}...`}
              indicator={<Loading3QuartersOutlined spin />}
              spinning={isSpinning}
            >
              <Progress
                type="circle"
                strokeColor={self.strokeColor}
                percent={self.downloadPercent}
                status={self.progressStatus}
              />
            </Spin> */}
            <div className={styles.loading}>
              <img className={styles.loadingIcon} src="/loading.svg" alt="loading" />
              <span className={styles.loadingText}>{i18n.t('email.result.loading')}...</span>
            </div>
          </div>
        )
      },
      renderContent: null,
      render: () => {
        if (modalExt.renderContent != null) {
          return modalExt.renderContent()
        }
        return modalExt.renderProgress()
      },
      modal: null,
      update: () => {},
      download: () => {},
    }

    modalExt.modal = Modal.info({
      wrapClassName: classNames(styles.mediaPopup, modalExt.clsNames),
      title: modalExt.getTitle(),
      icon: null,
      content: modalExt.render(),
      closeIcon: <img src={closeSVG} alt="close" />,
      closable: false,
      maskClosable: true,
      centered: true,
      zIndex: 1900,
      getContainer: () => {
        return container || document.body
      },
      afterClose: () => {
        if (modalExt.afterClose != null) {
          modalExt.afterClose()
        }
      },
      okButtonProps: { disabled: true },
      cancelButtonProps: { disabled: true },
      maskTransitionName: 'maskTransitionName',
    })

    modalExt.update = (options?: any) => {
      let opts = {
        wrapClassName: classNames(styles.mediaPopup, modalExt.clsNames),
        title: modalExt.getTitle(),
        content: modalExt.render(),
        closable: false,
      }
      if (modalExt.renderContent != null) {
        opts.closable = true
      }
      if (options != null) {
        opts = { ...opts, ...options }
      }
      modalExt.modal.update(opts)
    }

    const onProgress = (evt: any, percent?: number) => {
      if (evt != null && evt.total === 0) {
        // console.log(' loaded - ', evt.loaded, attachment.info.filesize);
        const fileSize = self.info?.filesize || 0
        self.downloadPercent = Math.round((evt.loaded * 100) / fileSize)
      } else if (percent != null) {
        self.downloadPercent = Math.round(percent)
      }

      console.log(' onProgress - ', evt, self.downloadPercent)

      modalExt.stopSpinning()

      modalExt.update()
    }

    modalExt.startSpinning()

    modalExt.download = (options?: DownloadOptions) => {
      console.log(' - req download : ', self)
      self
        .download(onProgress)
        .then(async (ret) => {
          console.log(' - download : ', ret)
          modalExt.stopSpinning()

          modalExt.afterClose = () => {
            self.cancelProgress()
            // window.URL.revokeObjectURL(downloadPath)
            // if (path != null) {
            //   window.URL.revokeObjectURL(path)
            // }
          }

          if (options != null) {
            const { onDownload } = options
            if (onDownload != null) {
              await onDownload(ret)
            }
          }

          modalExt.update()
        })
        .catch((err: any) => {
          if (err.type === 'invalidEML') {
            modalExt.renderContent = () => {
              return null
            }
            modalExt.update()
            errorBase({
              title: 'Invalid EML',
              content: i18n.t('email.desc.invaidEML'),
              afterClose: () => {
                modalExt.modal.destroy()
              },
            })
            return
          }
          console.log(err)
          self.progressStatus = 'exception'
          onProgress(null, 0)
        })
    }

    modalExt.download(downloadOptions)

    return modalExt
  }

  self.showImage = () => {
    console.log(' showImage - ', self)

    const modalExt = self.showPopup(styles.image, {
      onDownload: (downloadObj: any) => {
        const { path, saveFile } = downloadObj

        self.viewerVisible = true

        function closeModal() {
          self.viewerVisible = false
          modalExt.update()
          modalExt.modal.destroy()
        }

        modalExt.renderTitle = () => {
          return 'Image viewer'
        }

        modalExt.clsNames = classNames(styles.image, styles.viewer)

        modalExt.renderContent = () => {
          const viewAttr = {
            visible: self.viewerVisible,
            onClose: () => {
              closeModal()
            },
            // onMaskClick: () => {
            //   closeModal()
            // },
            viewerOptions: {
              navbar: false,
            },
            images: [
              { src: path, alt: self.file.name },
              // { src: '', alt: 'test' }
            ],
            onDownload: () => {
              saveFile()
            },
          }

          return (
            <div className={styles.content}>
              <div className={styles.scaleWrapper}>
                <Viewer {...viewAttr} />
              </div>
            </div>
          )
        }
      },
    })
  }

  self.showVideo = () => {
    console.log(' showVideo - ', self)

    const { file } = self
    const { type } = file

    self.isVideo = type.toLowerCase().indexOf('video') === 0

    const modalExt = self.showPopup(styles.video, {
      onDownload: (downloadObj: any) => {
        const { path, saveFile } = downloadObj

        self.canPlay = ReactPlayer.canPlay(path)

        console.log(' - canPlay ? - ', self.canPlay, file.name, path)

        let viewW = 'min(90vw, 640px)'
        let viewH = 'min(90vh, 350px)'

        const onReady = (e: any) => {
          console.log(' - onReady : ', e)
          const player = e.getInternalPlayer()
          if (
            player.tagName === 'VIDEO' &&
            player.videoWidth != null &&
            player.videoHeight != null
          ) {
            const w = player.videoWidth
            const h = player.videoHeight

            if (w > 0 && h > 0) {
              viewW = `min(90vw, ${w}px)`
              viewH = `min(90vh, ${h}px)`

              modalExt.update()
            }
          }
        }

        const onError = (e: any) => {
          console.log(' - onError : ', e)
        }

        modalExt.renderTitle = () => {
          return (
            <div className={styles.topBtns}>
              <Tooltip placement="bottom" title="Download">
                <Button
                  type="default"
                  size="small"
                  icon={<img src={downloadSVG} alt="download" width={20} height={20} />}
                  onClick={saveFile}
                />
              </Tooltip>
            </div>
          )
        }

        modalExt.clsNames = classNames(styles.video, styles.viewer)

        modalExt.renderContent = () => {
          const playerAttrs: any = {
            config: {
              file: {
                forceAudio: self.isVideo !== true,
              },
            },
          }

          playerAttrs.width = viewW
          playerAttrs.height = viewH

          return (
            <div className={styles.content}>
              <ReactPlayer
                url={path}
                controls
                onReady={onReady}
                onError={onError}
                {...playerAttrs}
              />
            </div>
          )
        }
      },
    })
  }

  self.showText = () => {
    console.log(' showText - ', self)

    const modalExt = self.showPopup(styles.text, {
      onDownload: (downloadObj: any) => {
        const { text, saveFile } = downloadObj

        modalExt.renderTitle = () => {
          return (
            <div className={styles.header}>
              <span className={styles.filename}>
                <FTIcon fileName={self.file.name} />
                {self.file.name}
              </span>
              <Tooltip placement="bottom" title={i18n.t('common.title.download')}>
                <Button
                  type="text"
                  size="small"
                  icon={
                    <SVGImageCurrentColor src={downloadSVG} alt="download" width={24} height={24} />
                  }
                  onClick={saveFile}
                />
              </Tooltip>
              <div className={styles.space} />
            </div>
          )
        }

        modalExt.clsNames = classNames(styles.text, styles.viewer)

        modalExt.renderContent = () => {
          return (
            <div className={styles.content}>
              <pre>{text}</pre>
            </div>
          )
        }

        setTimeout(() => {
          modalExt.update()
        }, 100)
      },
    })
  }

  self.showEML = (container: any, apiMap: any) => {
    console.log(' showEML - ', self, apiMap)

    const modalExt = self.showPopup(
      styles.eml,
      {
        onDownload: async (downloadObj: any) => {
          const { blob, saveFile } = downloadObj

          const emlBuffer = await blob.arrayBuffer()

          const postalMimeEML = await parseEMLByPostalMime(emlBuffer)

          const email = await createEMLEmail(postalMimeEML)

          console.log(' --- email data : ', postalMimeEML)

          const threadViewProps = {
            innerRef: null,
            emails: [email],
            email: null,
            curEmail: email,
            isThreadMode: false,
            curMailbox: null,
            ...apiMap,
          }

          // const emlData = readEml(emlText)
          // console.log(' --- eml data : ', emlData)

          // const { htmlheaders } = emlData;
          // if (htmlheaders != null) {
          //   const contentTypeKey = Object.keys(htmlheaders).find((key) => key.toLowerCase() === 'content-type')
          //   if (contentTypeKey != null) {
          //     const contentType = htmlheaders[contentTypeKey]
          //     const pairs = contentType.split(';')
          //     const map = {}
          //     pairs.forEach((pair) => {
          //       const tmp = pair.split('=');
          //       if (tmp.length === 2) {
          //         const key = tmp[0].trim().toLowerCase();
          //         if (key != null && key.length > 0) {
          //           map[key] = tmp[1].trim()
          //         }
          //       }
          //     })
          //     if (map.charset == null || map.charset.length === 0) {
          //       const htmlBytes = forge.util.binary.raw.decode(emlData.html)
          //       const encoding = htmlEncodingSniffer(htmlBytes)
          //       const decodedHtml = new TextDecoder(encoding).decode(htmlBytes)
          //       console.log(' --- decoded html : ', decodedHtml, encoding)
          //       postalMimeEML.html = decodedHtml
          //     }
          //   }
          // }

          // modalExt.renderTitle = () => {
          //   return (
          //     <div className={styles.topBtns}>
          //       <Tooltip placement="bottom" title="Download">
          //         <Button
          //           type="default"
          //           size="small"
          //           icon={<img src={downloadSVG} alt="download" width={20} height={20} />}
          //           onClick={saveFile}
          //         />
          //       </Tooltip>
          //     </div>
          //   )
          // }

          // modalExt.renderContent = () => {
          //   return (
          //     <Provider store={store}>
          //       <div className={styles.content}>
          //         <EmailView postalMimeEML={postalMimeEML} />
          //       </div>
          //     </Provider>
          //   )
          // }

          modalExt.renderTitle = () => {
            return (
              <div className={styles.header}>
                <span className={styles.filename}>
                  <FTIcon fileName={self.file.name} />
                  {self.file.name}
                </span>
                <Tooltip placement="bottom" title={i18n.t('common.title.download')}>
                  <Button
                    type="text"
                    size="small"
                    icon={
                      <SVGImageCurrentColor
                        src={downloadSVG}
                        alt="download"
                        width={24}
                        height={24}
                      />
                    }
                    onClick={saveFile}
                  />
                </Tooltip>
                <div className={styles.space} />
              </div>
            )
          }

          modalExt.clsNames = classNames(styles.eml, styles.viewer)

          modalExt.renderContent = () => {
            return (
              <Provider store={store}>
                <div className={styles.content}>
                  <ThreadView {...threadViewProps} />
                </div>
              </Provider>
            )
          }

          setTimeout(() => {
            modalExt.update()
          }, 100)
        },
      },
      container,
    )
  }

  // interface WindowSize {
  //   width: number
  //   height: number
  // }

  // const getViewerWindowSize = (): WindowSize => {
  //   return {
  //     width: Math.min(window.screen.availWidth, 1024),
  //     height: Math.min(window.screen.availHeight, 768),
  //   }
  // }

  self.showDOC = () => {
    console.log(' showText - ', self)

    // Safari: 팝업 차단 우회 — 사용자 클릭 컨텍스트에서 미리 about:blank를 열어둠.
    // Firefox: Document-Isolation-Policy 미지원으로 iframe에서 SAB/WASM threads 동작 불가 →
    //          Safari와 동일하게 별도 top-level 창에서 열어 자체 cross-origin isolated 상태로 동작.
    let externalWin: Window | null = null
    if (isSafari || isFirefox) {
      externalWin = window.open('about:blank', '_blank')
    }

    const modalExt = self.showPopup(styles.doc, {
      onDownload: (downloadObj: any) => {
        const { path, file, saveFile } = downloadObj

        if (externalWin != null) {
          modalExt.modal.destroy()
          const url = buildDocViewerUrl(encodeURIComponent(path), file.name)
          externalWin.location.href = url
          return
        }

        const onExpand = () => {
          modalExt.modal.destroy()
          setTimeout(() => {
            const url = buildDocViewerUrl(encodeURIComponent(path), file.name)
            window.open(url, '_blank')
          }, 100)
        }

        modalExt.renderTitle = () => {
          return (
            <div className={styles.header}>
              <span className={styles.filename}>
                <FTIcon fileName={self.file.name} />
                {self.file.name}
              </span>
              <Tooltip placement="bottom" title={i18n.t('common.title.download')}>
                <Button
                  type="text"
                  size="small"
                  icon={
                    <SVGImageCurrentColor src={downloadSVG} alt="download" width={24} height={24} />
                  }
                  onClick={saveFile}
                />
              </Tooltip>
              <div className={styles.space} />
              <Tooltip placement="bottom" title={i18n.t('common.title.openInNewWindow')}>
                <Button
                  type="text"
                  size="small"
                  icon={
                    <SVGImageCurrentColor
                      src={openInSVG}
                      alt="open in new window"
                      width={24}
                      height={24}
                    />
                  }
                  onClick={onExpand}
                />
              </Tooltip>
            </div>
          )
        }

        modalExt.clsNames = classNames(styles.doc, styles.viewer)

        modalExt.renderContent = () => {
          return (
            <div className={styles.content}>
              <DocViewer fileUrl={encodeURIComponent(path)} fileName={file.name} />
            </div>
          )
        }

        setTimeout(() => {
          modalExt.update()
        }, 100)
      },
    })
  }

  self.showPreview = (apiMap?: any): boolean => {
    console.log(' showPreview - ', self)

    let ret = true

    const { file } = self
    if (file != null && file.type != null) {
      const viewType = getPreviewType(file)

      switch (viewType) {
        case 1:
          self.showImage()
          break
        case 2:
          self.showVideo()
          break
        case 3:
          self.showText()
          break
        case 4:
          self.showEML(null, apiMap)
          break
        case 5:
          self.showDOC()
          break
        default:
          console.log(' --- unsupported file type : ', file)
          // errorBase({
          //   title: null,
          //   content: 'Unsupported file type',
          // })
          ret = false
      }
    }

    return ret
  }

  return self
}

const helper = {
  extendUI,
}

export default helper
